import { FileTypeEnum } from 'utils'

import Button from 'components/uiKit/Button'
import Card from 'components/uiKit/Card'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import Modal, { MCWithParams, ModalBody, ModalFooter, ModalHeader } from 'components/uiKit/Modal'
import { Typography } from 'components/uiKit/Typography'
import { useFileMetaGetById } from 'gql/files/apollo'
import { t } from 'services/Translation'
import { prepareFinderItem } from 'utils/useFinder'

import { FinderFileIcons } from '../FinderFileIcons'
import * as s from './FinderReplaceConfirmationModal.module.scss'

interface IFinderReplaceConfirmationParams {
  sourceFileId: string
  targetFileId: string
}

const FinderReplaceConfirmationModal: MCWithParams<IFinderReplaceConfirmationParams, boolean> = ({
  params,
  onClose,
}) => {
  const { sourceFileId, targetFileId } = params
  const { data: sourceFileData, loading: sourceLoading } = useFileMetaGetById(sourceFileId)
  const { data: targetFileData, loading: targetLoading } = useFileMetaGetById(targetFileId)

  const preparedSourseFile = sourceFileData?.data && prepareFinderItem(sourceFileData.data, '')
  const preparedTargetFile = targetFileData?.data && prepareFinderItem(targetFileData.data, '')

  return (
    <Modal name='FinderReplaceConfirmationModal'>
      <ModalHeader title={t('modal.replaceFileConfirmation.title')} />
      <ModalBody sizeAutoCapable>
        <div className={s.cards}>
          <div className={s.card}>
            <Card hovered={false} loading={sourceLoading} name='sourceFile'>
              <FinderFileIcons
                item={preparedSourseFile!}
                typeFile={sourceFileData?.data?.type.split('/')[0] as FileTypeEnum}
              />
            </Card>
            <Typography rows={1} weight='medium' wordBreak='break-all'>
              {preparedSourseFile?.name}
            </Typography>
          </div>
          <div className={s.icon}>
            <Icon name='sort' size={KitSize.S} />
          </div>
          <div className={s.card}>
            <Card hovered={false} loading={targetLoading} name='targetFile'>
              <FinderFileIcons
                item={preparedTargetFile!}
                typeFile={targetFileData?.data?.type.split('/')[0] as FileTypeEnum}
              />
            </Card>
            <Typography rows={1} weight='medium' wordBreak='break-all'>
              {preparedTargetFile?.name}
            </Typography>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button name='cancelButton' onClick={() => onClose(false)} styleType='ghost'>
          {t('uiKit.button.cancel')}
        </Button>
        <Button
          loading={targetLoading || sourceLoading}
          name='confirmButton'
          onClick={() => onClose(true)}
        >
          {t('uiKit.button.apply')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FinderReplaceConfirmationModal
